export const mensagemPorCodigo = {
    erro: {
        '001': 'Data inválida.',
        '002': 'Preencha pelo menos um dos campos para prosseguir com a consulta.',
        '003': 'Data final deve ser maior ou igual que a data inicial.',
        '004': 'Período máximo de consulta é 60 dias.',
        '005': 'Nome deve possuir pelo menos 5 caracteres.',
        '035': 'Data inicial deve ser preenchida.'
    }
}

const mensagem = {
  erro: {
    inesperado: 'Ocorreu um erro inesperado. Contacte o administrador do sistema.'
  },
  pesquisa: {
    vazia: 'Não existe conteúdo a ser exibido',
    erro: 'Ocorreu um problema ao executar a pesquisa',
    executando: 'Pesquisando...'
  },
  campo: {
    obrigatorio: 'Favor preencher o campo "{0}"',
    invalido: 'Campo "{0}" com valor inválido'
  }
}

export const mensagemPorChave = (chave, arrayParam) => {
  let msg = ''
  if((chave) && (chave.length > 0)) {
    let props = chave.split('.')
    let temp  = mensagem
    for(let p of props) {
      temp = temp[p];
      if(!temp) {
        break;
      }
    }
    if(typeof temp === 'string') {
      msg = temp;
      if(Array.isArray(arrayParam)) {
        for(let i=0; i<arrayParam.length; i++) {
          msg = msg.replace('{' + i + '}', arrayParam[i]);
        }
      }
    }
  }
  return msg;
}